@if (showPen && !lukittu) {
  <app-icon-button (click)="toggleEdit()" actionId="Avasi dialogin: Veroilmoitus > Avaa muokkaa kynä" [dynamicClass]="{ 'edit-pen-active': editing }" additionalClass="edit-pen">
    <span class="fa fa-pencil"></span>
  </app-icon-button>
}

<div class="tili-num">{{ numero }}</div>
<div class="long-col" [class.has-label]="!!label">
  <div>{{ label }}</div>
  <div class="option-container" [class.two-col]="twoCol">
    @if (!twoCol) {
      <mat-radio-group (change)="tallennaMuuttunutArvo($event)" [formField]="arvo">
        @for (option of options; track option) {
          <mat-radio-button [value]="option.value" class="dense" style="margin-left: 10px">{{ option.label }}</mat-radio-button>
          @if (direction === 'vertical') {
            <br />
          }
        }
      </mat-radio-group>
    }
    @if (!twoCol) {
      <div class="option-container-indicator-container">
        @if (saving) {
          <span class="saving" [@slowInQuickOut]="'in'">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </span>
        }
        @if (saveSuccess) {
          <span class="save-success" [@quickInSlowOut]="'in'">
            <mat-icon [@quickInSlowOut]="'in'" [ngStyle]="{ color: '#4bd76b', 'vertical-align': 'middle', 'margin-bottom': '6px' }">done</mat-icon>
            Valinta tallennettiin
          </span>
        }
        @if (saveFailure) {
          <span class="save-failure">
            <mat-icon [ngStyle]="{ color: 'rgb(255, 72, 102)', 'vertical-align': 'middle' }">error_outline</mat-icon>
            Tallentamisen aikana tapahtui virhe. Ole hyvä ja yritä uudelleen.
          </span>
        }
      </div>
    }
  </div>
  @if (kenttaVirhe) {
    <div class="kentta-virhe-container">
      @for (virheViesti of kentanVirheViestit; track virheViesti) {
        <div class="kentta-virhe-rivi">
          <mat-icon class="kentta-virhe-ikoni">error_outline</mat-icon>
          <span>{{ virheViesti }}</span>
        </div>
      }
    </div>
  }
</div>
<div class="short-col" style="display: flex; align-items: center; justify-content: flex-end">
  @if (twoCol) {
    <mat-radio-group (change)="tallennaMuuttunutArvo($event)" [formField]="arvo">
      @for (option of options; track option) {
        <mat-radio-button [value]="option.value" class="dense" style="margin-left: 10px">{{ option.label }}</mat-radio-button>
        @if (direction === 'vertical') {
          <br />
        }
      }
    </mat-radio-group>
  }
</div>
